import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './i18n'; // Initialize i18n
import { ensureCorrectDirection } from './i18n';
import AppRouter from './AppRouter';

export default function App() {
  const { i18n } = useTranslation();
  
  // Safety check: ensure document direction matches language after React hydrates.
  // This fixes race conditions where i18n.language wasn't ready during initial load
  // on some phones/browsers.
  useEffect(() => {
    // Check immediately
    ensureCorrectDirection();
    
    // Also check after a short delay (for slow devices)
    const timeout1 = setTimeout(() => {
      ensureCorrectDirection();
    }, 100);
    
    const timeout2 = setTimeout(() => {
      ensureCorrectDirection();
    }, 500);
    
    return () => {
      clearTimeout(timeout1);
      clearTimeout(timeout2);
    };
  }, []);
  
  // Also re-check whenever language changes (belt and suspenders)
  useEffect(() => {
    const lang = i18n.language || i18n.resolvedLanguage || 'en';
    const isRTL = lang === 'he';
    const currentDir = document.documentElement.dir;
    const expectedDir = isRTL ? 'rtl' : 'ltr';
    
    if (currentDir !== expectedDir) {
      document.documentElement.dir = expectedDir;
      document.documentElement.lang = lang;
    }
    
    // Double-check after a short delay
    const timeout = setTimeout(() => {
      const currentDir2 = document.documentElement.dir;
      if (currentDir2 !== expectedDir) {
        document.documentElement.dir = expectedDir;
        document.documentElement.lang = lang;
      }
    }, 50);
    
    return () => clearTimeout(timeout);
  }, [i18n.language, i18n.resolvedLanguage]);
  
  return <AppRouter />;
}
